import React from 'react';

//Return text if package not found
const NoPackage = () =>{
    return (
   <div className="thanks_wrapper">
       <p className="thanks_msg">
        Thanks for visiting, we will be available in your area soon
       </p>
   </div>
    )
}

export default NoPackage;


// WEBPACK FOOTER //
// ./web/components/package/NoPackage.js